const convertedVapidKey = urlBase64ToUint8Array(
  process.env.REACT_APP_PUBLIC_VAPID_KEY
);

function urlBase64ToUint8Array(base64String) {
  // console.log(base64String)
  const padding = "=".repeat((4 - (base64String.length % 4)) % 4);
  // eslint-disable-next-line
  const base64 = (base64String + padding)
    // eslint-disable-next-line no-useless-escape
    .replace(/\-/g, "+")
    .replace(/_/g, "/");

  const rawData = window.atob(base64);
  const outputArray = new Uint8Array(rawData.length);

  for (let i = 0; i < rawData.length; ++i) {
    outputArray[i] = rawData.charCodeAt(i);
  }
  return outputArray;
}

function sendSubscription(subscription, token) {
  console.log(subscription);
  return fetch(`${process.env.REACT_APP_BASE_URL}webpush/subscribe`, {
    method: "POST",
    body: JSON.stringify(subscription),
    headers: {
      "access-control-allow-origin": "*",
      "Content-Type": "application/json",
      Authorization: "Bearer " + token,
    },
  });
}

export function subscribeUser(token) {
  if ("serviceWorker" in navigator) {
    console.log("Calling subscription");

    navigator.serviceWorker.ready
      .then(function (registration) {
        console.log("Calling subscription 2");

        if (!registration.pushManager) {
          console.log("Push manager unavailable.");
          return;
        }

        registration.pushManager
          .getSubscription()
          .then(function (existedSubscription) {
            if (existedSubscription === null) {
              console.log("No subscription detected, make a request.");
              registration.pushManager
                .subscribe({
                  applicationServerKey: convertedVapidKey,
                  userVisibleOnly: true,
                })
                .then(function (newSubscription) {
                  console.log("New subscription added.", newSubscription);
                  sendSubscription(newSubscription, token);
                })
                .catch(function (e) {
                  if (Notification.permission !== "granted") {
                    console.log("Permission was not granted.");
                  } else {
                    console.error(
                      "An error ocurred during the subscription process.",
                      e
                    );
                  }
                });
            } else {
              console.log("Existed subscription detected.");
              sendSubscription(existedSubscription, token);
            }
          });
      })
      .catch(function (e) {
        console.log("Error");
        console.error(
          "An error ocurred during Service Worker registration.",
          e
        );
      });
  }
}
